import axios from 'axios'
import store from '@/store'
import router from '@/router'

export default {
  async execute (method, resource, data) {
    // inject the accessToken for each request
    let accessToken = await store.getters.token
    return axios({
      method,
      json: true,
      url: resource,
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(req => {
      return req.data
    }).catch(error => {
      const { response } = error
      const { request, ...errorObject } = response // take everything but 'request'
      if (errorObject.status === 401) {
        store.dispatch('LogOut')
        router.push('/Projekte')
      }
    })
  },

  overview () {
    return this.execute('get', '/api/generic/overview')
  },
  statistics () {
    return this.execute('get', '/api/generic/statistics')
  },
  information (type) {
    return this.execute('get', 'api/generic/information/' + type)
  },
  list (type, offset, size, filter) {
    let params = ''
    if (filter.name) {
      params = '?name=' + encodeURI(filter.name)
    }
    return this.execute('get', '/api/generic/list/' + type + '/' + offset + '/' + size + params)
  },
  get (type, id) {
    return this.execute('get', `/api/generic/get/${type}/${id}`)
  },
  update (type, id, data) {
    return this.execute('post', `/api/generic/update/${type}/${id}`, data)
  },
  delete (url) {
    return this.execute('delete', url)
  }
}



// WEBPACK FOOTER //
// ./src/main/vue/api/generic.js